/**
 * The number of seconds the application will wait before refreshing bolt-ons from the server.
 */
export const BoltOnsStateCacheTimeout = 3600;

/**
 * The number of seconds the application will wait before refreshing bundle top-ups from the server.
 */
export const BundleTopupsStateCacheTimeout = 3600;

/**
 * The number of seconds the application will wait before refreshing excluded provisioning days from the server.
 */
export const ExcludedProvisioningDaysStateCacheTimeout = 3600;

/**
 * The number of seconds the application will wait before refreshing tariffs from the server.
 */
export const TariffsStateCacheTimeout = 3600;

/**
 * The number of seconds the application will wait before refreshing available networks to port to from the server.
 */
export const PortNetworksCacheTimeout = 3600;

/**
 * The number of seconds the application will wait before refreshing ornage provisioning zones from the server.
 */
export const OrangeProvisioningZonesCacheTimeout = 86400;

/**
 * The number of seconds the application will wait before refreshing mvno templates from the server.
 */
export const MvnoTemplatesCacheTimeout = 86400;
